
<template>
  <div style="background-color: rgba(236, 243, 255, 1);">
    <section class="section">
      <div class="card-container">
        <div class="card-item">
          <div class="card-text">
            <p>明晟人工智能产业研究院由华中科技大学教授王祖喜担任执行院长。已聘任专家59人，其中教授39人、副教授12人；建立3个科技研发平台、5个校企合作共建平台、16个实习实训基地。</p>
          </div>
          <div class="card-img">
            <img src="./assets/img/card-feature1.png" alt="智能工厂">
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <div style="display: flex;justify-content: center;margin-top: 35px;margin-bottom: 30px">
        <h2 class="section-title">专家库</h2>
      </div>
      <div class="section_7 flex-row justify-center">
        <div class="image-wrapper_1 flex-col" style="margin-right: 30px">
          <img class="image_5" referrerpolicy="no-referrer"
               src="./assets/img/MasterDDSSlicePNG4df5d08bc682384333eca2b0f229b7b3.png" />
        </div>
        <div class="text-group_9 flex-col">
          <span class="text_10">王祖喜-博士</span>
          <span class="text_11">
              明晟人工智能产业研究院执行院长，华中科技大学人工智能与自动化学院副教授，硕士生导师
            </span>
          <span class="text_12">
              主要从事网络空间安全、混沌密码技术、人工智能与复杂网络等相关领域理论和技术与应用研究和教学工作，主持和参加包括国家自然科学基金、国家“863”计划项目、“十一五”“十二五”国家密码发展基金、科技部国家中小企业创新基金等国家级和省部级纵向科研项目以及横向科研项目三十余项。
            </span>
        </div>

      </div>
      <div class="section_8 flex-row justify-center">
        <img class="label_1" referrerpolicy="no-referrer"
             src="./assets/img/MasterDDSSlicePNGdd5f845a26da1af861d9b6b145efead6.png" />
        <div class="image-wrapper_4 flex-row">
          <img class="image_6" referrerpolicy="no-referrer" :src="item.lanhuimage0" v-for="(item, index) in loopData0"
               :key="index" />
        </div>
        <img class="label_2" referrerpolicy="no-referrer"
             src="./assets/img/MasterDDSSlicePNGb944e4ef6ae3c2f756e942e17fc09637.png" />
      </div>
    </section>
    <section class="section">
      <div style="display: flex;justify-content: center;margin-top: 65px;margin-bottom: 30px">
        <h2 class="section-title">人才库</h2>
      </div>
      <div class="card-container">
        <div class="card-item">
          <div class="card-text">
            <p style="text-align: justify">通过与多所高校的深度合作，明晟研究院汇聚了一支跨学科的高水平研究团队。
              团队成员涵盖了人工智能、计算机科学、经济管理、财会、国际贸易等十余个专业领域，
              具备了多元化的研究优势。研究院中，<span style="color: #0767FC">约40%的研究人员拥有博士学位，40%的研究人员具有硕士学位，20%的研究人员为本科生
                。</span>这样的团队结构不仅为研究院提供了强大的技术支持，也为各领域的交叉融合和创新发展奠定了坚实基础。
            </p>
          </div>
          <div class="group_2 flex-col">
            <div class="text-wrapper_25 flex-row"><span class="text_16">硕士学位：40%</span></div>
            <div class="text-wrapper_26 flex-row"><span class="text_17">博士学位：40%</span></div>
            <div class="text-wrapper_27 flex-row"><span class="text_18">本科生：20%</span></div>
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <div style="display: flex;flex-direction:column;align-items:center;justify-content: center;margin-top: 65px;margin-bottom: 30px">
        <h2 class="section-title">产学研合作</h2>
        <p style="font-weight: 400;font-size: 22px;color: #333333;margin-top: 20px">全方位助力产业结构迈向高端化、合理化，为企业注入澎湃发展动力</p>
      </div>
      <div class="card-container">
        <div class="card-item">
          <div class="card-text">
            <p style="text-align: justify">
              作为产学研深度融合的关键枢纽，充分发挥桥梁纽带效能，精准锚定头部产业前沿资源，
              深度挖掘高校、科研院所的学术富矿，全力构建科技、产业、学术紧密联动的良性生态循环。
              研究院广聚各方智慧，聚焦于项目实战，搭建科技成果转化的高速通道，
              实现前沿科技与产业需求的无缝对接；导入先进管理理念与模式，为产业赋能增效；同时，
              凭借敏锐的市场洞察力与专业的孵化能力，助力新兴产业破壳成长。为区域经济腾飞插上高质量发展的翅膀。
            </p>
          </div>
          <div class="card-img">
            <img src="./assets/img/MasterDDSSlicePNG0e5311ad9e0c0fcc3eb6786d408ea612.png" alt="智能工厂">
          </div>
        </div>
      </div>
    </section>
  </div>

</template>

<script>

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
  data(){
    return {
      loopData0: [
        { lanhuimage0: 'https://lanhu-oss.lanhuapp.com/MasterDDSSlicePNG42b1c93f9ade2ca4049ccf7681ef92b6.png' },
        { lanhuimage0: 'https://lanhu-oss.lanhuapp.com/MasterDDSSlicePNG358e7933c20268b7359384712c99604e.png' },
        { lanhuimage0: 'https://lanhu-oss.lanhuapp.com/MasterDDSSlicePNG79c3313b6677c31b6fd90fb3a9108ca9.png' },
        { lanhuimage0: 'https://lanhu-oss.lanhuapp.com/MasterDDSSlicePNG9def00962c59f3a4fb34125fbdfc7bc3.png' },
        { lanhuimage0: 'https://lanhu-oss.lanhuapp.com/MasterDDSSlicePNG2a2b5f9646c9cf9f7a043bcb17fb4108.png' }
      ],
    }
  }
}
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped lang="css">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  line-height: 1.6;
  color: #333;
}
.banner {
  height: 500px;
  //width: 100vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100% ;
  //text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-image:  url("./assets/img/banner.png");
}
.section-title {
  font-size: 32px;
  color: #181F5C;
  margin-bottom: 20px;
  position: relative;
  text-align: center;
  font-family: "Alimama ShuHeiTi-Bold";
}
.section-title:before{
  left: -135px !important;
}
.section-title:after{
  right: -135px !important;
}
.section-title:before {
  content: "";
  background-image: url('assets/img/title-icon-left.png');
  position: absolute;
  width: 112px;
  height: 59px;
  //background-color: #0052d9;
  bottom: -10px;

  //transform: translateX(-50%);
}
.section-title:after {
  content: "";
  background-image: url('assets/img/title-icon-right.png');
  position: absolute;
  width: 112px;
  height: 59px;
  //background-color: #0052d9;
  bottom: -10px;
  right: 185px;
  //transform: translateX(-50%);
}
.feature-section {
  background-color: #fff;
  padding: 40px 0;
}

.card-container {
  max-width: 1200px;
  margin: 0 auto;
}

.card-item {
  display: flex;
  margin-bottom: 40px;
  align-items: center;
}

.card-item:nth-child(even) {
  flex-direction: row-reverse;
}

.card-img {
  flex: 1;
  padding: 20px;
}

.card-img img {
  width: 100%;
  //border-radius: 10px;
  //box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.card-text {
  flex: 1;
  padding: 20px;
  text-align: left;
}

.card-text h3 {
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  font-family: "Alimama ShuHeiTi-Bold";
}

.card-text p {
  width: 560px;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  margin-top: 20px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* 顶部导航 */
.header {
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 100;
}

.header .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
}

.nav ul {
  display: flex;
  list-style: none;
}

.nav li {
  margin-left: 30px;
}

.nav a {
  text-decoration: none;
  color: #333;
  font-size: 16px;
}

.nav a:hover {
  color: #0066cc;
}

/* 产品特点 */
.features {
  padding: 10px 0;
  //background: #f8f9fa;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1px;
}

.feature-item {
  height: 334px;
  //width: 100vw;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100% ;
  //text-align: center;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
}
.feature-item h3{
  font-weight: 700;
  font-size: 28px;
  color: #FFFFFF;
  font-family: "Alimama ShuHeiTi-Bold";
  margin-bottom: 20px;
}
.feature-item p{
  font-weight: 400;
  font-size: 20px;
  color: #FFFFFF;

}
.feature-item:nth-child(1) {
  background-image:  url("./assets/img/about-features3.png");
}
.feature-item:nth-child(2) {
  background-image:  url("./assets/img/about-features2.png");
}
.feature-item:nth-child(3) {
  background-image:  url("./assets/img/about-features1.png");
}
.feature-img img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 4px;
}

/* 发展大事记 */
.timeline {
  padding: 60px 0;
}

.timeline h2 {
  text-align: center;
  margin-bottom: 40px;
}

.timeline-wrapper {
  display: flex;
  justify-content: space-between;
  position: relative;
  padding: 20px 0;
}

.timeline-wrapper::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 2px;
  background: #0066cc;
}

.timeline-item {
  position: relative;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  z-index: 1;
}

.year {
  font-size: 24px;
  font-weight: bold;
  color: #0066cc;
  margin-bottom: 10px;
}

.events {
  list-style: none;
}

.events li {
  margin-bottom: 8px;
  font-size: 14px;
}

/* 企业荣誉 */
.honor {
  padding: 60px 0;
  background: #f8f9fa;
}

.honor-content {
  display: flex;
  align-items: center;
  gap: 30px;
}

.honor-text {
  flex: 1;
}

.honor-img {
  flex: 1;
}

.honor-img img {
  width: 100%;
  border-radius: 8px;
}

/* 战略布局 */
.strategy {
  padding: 20px 0 200px 0;
}

.map-container {
  position: relative;
  margin-top: 40px;
}

.china-map {
  position: relative;
}

.china-map img {
  width: 100%;
}

.location-points .point {
  position: absolute;
  width: 10px;
  height: 10px;
  background: #0066cc;
  border-radius: 50%;
  cursor: pointer;
}

.location-points .point::before {
  content: attr(data-name);
  position: absolute;
  white-space: nowrap;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
}

/* 页脚 */
.footer {
  background: #0066cc;
  color: #fff;
  padding: 40px 0;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.qr-codes {
  display: flex;
  gap: 20px;
}

.qr-code {
  text-align: center;
}

.qr-code img {
  width: 120px;
  height: 120px;
  background: #fff;
  padding: 10px;
  border-radius: 4px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .feature-grid {
    grid-template-columns: 1fr;
  }

  .timeline-wrapper {
    flex-direction: column;
    gap: 20px;
  }

  .timeline-wrapper::before {
    display: none;
  }

  .honor-content {
    flex-direction: column;
  }

  .footer-content {
    flex-direction: column;
    gap: 30px;
  }
}
</style>